import { Component, OnInit } from '@angular/core';
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {PagesService} from "../../services/pages.service";
import {ActivatedRoute} from "@angular/router";
import {UserService} from "../../services/user.service";
import {ApiService} from "../../services/api.service";
import { Title } from '@angular/platform-browser';
import {DomSanitizer} from '@angular/platform-browser';
import {MetatagService} from '../../services/metatag.service';


declare var ENV: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
    public form: FormGroup;
    public isLoggedIn = ApiService.isLoggedIn;
    public showModal = false;
    private baseUrl = ENV.api.baseUrl;
    public pageFound: boolean = true;

    public title: string = '';
    public content: string = '';

    constructor(private titleService: Title, private userService: UserService,private fb: FormBuilder, public sanitizer: DomSanitizer,
                private pagesService: PagesService, private activatedRoute: ActivatedRoute, private metatagService:MetatagService) {
        this.form = fb.group({
            emailAddress: ['', Validators.compose([Validators.required,Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])],
            password: ['', Validators.compose([Validators.required,Validators.minLength(8)])]
        });

        this.sanitizer = sanitizer;
    }

    ngOnInit() {

        this.activatedRoute.url.subscribe((path) => {
            let fullPath = path.join('/');

            this.pagesService.get(fullPath).subscribe((res)=>{
                this.pageFound = true;
                this.title = res.title[0].value;
                this.content = res.body[0].value;

                this.titleService.setTitle('Inloggen bij Dermabase');
            },(error) => {
                this.pageFound = false;
                this.title = '';
                this.content = '';

                this.titleService.setTitle('Dermabase - 404 page not found');
            });
        });

        this.metatagService.setMetaTags('', '');
    }

    submit() {
        if(!this.form.valid)
        {
            //TODO: create better error handling?
            alert('Vul alle velden correct in');
        }
        else
        {
            this.userService.login(
                this.form.value.emailAddress,
                this.form.value.password
            ).subscribe((res) => {
                ApiService.writeToken(res['csrf_token']);
                ApiService.writeToken(res['logout_token'],'logout_token');
            },(error) => {
                alert(error);
            })
        }
        return false;
    }

    getForgotPasswordUrl() {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.baseUrl + 'user/password');
    }

    toggleForgotPassword() {
        this.showModal = !this.showModal;
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/login/login.component.ts